import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';
import {VisionStepPerimeterKey} from './VisionStepPerimeterKey';

export class VisionStepPerimeter extends BasicEntity {
chronoCode: string;
code: string;
description: TranslatedEmb;
keys: VisionStepPerimeterKey[];
label: TranslatedEmb;
vid: number | null;
visionCode: string;
visionStepLevel: number | null;
}

